// import { Calendar } from "feather-icons-react/build/IconComponents";
import React, { useState, useEffect } from "react";
import CountUp from "react-countup";
// import "bootstrap-daterangepicker/daterangepicker.css";
// import DateRangePicker from "react-bootstrap-daterangepicker";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import { Link, useNavigate } from "react-router-dom";
import Axios from "axios";
import {
  API_BASE_URL,
  GET_DASHBOARD_TABLES_DATA,
  GET_DDL,
  GET_DASHBOARD_COUNT,
  GET_USER_PERMISSIONS,
  GET_LATE_INDENT_REQ,
  UPDATE_LATE_INDENT_REQ,
} from "../../Config";
import NoOfStores from "./noofstores.svg";
import Purchase from "./purchase.svg";
import Supplier from "./supplier.svg";
import PendingTransfer from "./pendingtransfer.svg";
import StockValue from "./stockvalue.svg";
import ViewIndent from "../../core/modals/purchases/viewindent";
import ViewPurchaseRequest from "../../core/modals/purchases/viewpurchaserequest";
import SupplierModal from "../../core/modals/peoples/supplierModal";
import ViewInvocie from "../../core/modals/purchases/viewinvoice";
// import ViewPurchase from "../../core/modals/purchases/viewpurchase";
import { Popover } from 'antd';
import SpinLoader from "../loader/SpinLoader";


const InventoryDashboard = () => {
  const [userDataSession, setUserDataSession] = useState([]);
  const [selectedStoreId, setSelectedStoreId] = useState(
    sessionStorage.getItem("selectedStoreId")
  );
  const [dashboardTablesData, setDashboardTablesData] = useState([]);
  const [dashboardCountsData, setDashboardCountsData] = useState([]);
  const [lateIndentReqs, setLateIndentReqs] = useState([]);
  const [lateIndentReqsLoading, setLateIndentReqsLoading] = useState(false);
  const [viewIndentObj, setViewIndentObj] = useState([]);
  const [viewPRObj, setViewPRObj] = useState([]);
  // const [viewPOObj, setViewPOObj] = useState([]);
  const [viewSupplierObj, setViewSupplierObj] = useState([]);
  const [viewInvoiceObj, setViewInvoiceObj] = useState([]);
  const [updatedRequests, setUpdatedRequests] = useState([]);
  const [loading, setLoading]=useState(false)
  const navigate = useNavigate();
  useEffect(() => {
    const userDataString = sessionStorage.getItem("userData");
    if (userDataString) {
      const userData = JSON.parse(userDataString);
      setUserDataSession(userData);
    } else {
      console.log("User data not found in sessionStorage");
      navigate("/");
    }
  }, []);

  useEffect(() => {
    const handleStoreIdChange = (event) => {
      const storeId = event.detail;
      setSelectedStoreId(storeId);
      console.log(storeId, "localstorage storeId updated in dashboard");
    };

    window.addEventListener("storeIdChanged", handleStoreIdChange);
    console.log(selectedStoreId, "initial storeId from sessionStorage");

    return () => {
      window.removeEventListener("storeIdChanged", handleStoreIdChange);
    };
  }, []);


  const fetchDashboardData = async () => {

    setLoading(true)
      const table_api = `${API_BASE_URL}${GET_DASHBOARD_TABLES_DATA}?OrgId=${userDataSession.OrgId}&StoreId=0&UserId=${userDataSession.UserId}`;
      console.log(table_api, "for allllllllllllllllllllllllllllllll");
      try {
        const tablesResponse = await Axios.get(table_api);
        setDashboardTablesData(tablesResponse.data);
        console.log(tablesResponse.data, "tableresposne.dataaaaa");

        const countsResponse = await Axios.get(
          `${API_BASE_URL}${GET_DASHBOARD_COUNT}?OrgId=${userDataSession.OrgId}&UserId=${userDataSession.UserId}`
        );
        setDashboardCountsData(countsResponse.data.ResultData);
      } catch (error) {
        console.error(
          "Error fetching dashboard data:",
          error.response ? error.response.data : error.message
        );
      }
      finally{
        setLoading(false);
      }
    };

  useEffect(() => {
  
    if (userDataSession && userDataSession.OrgId) {
      fetchDashboardData();
    }
  }, [userDataSession]);

  useEffect(() => {
    if (userDataSession && userDataSession.OrgId) {
      fetchUserPermissions();
    }
  }, [userDataSession]);

  const fetchUserPermissions = () => {
    Axios.get(
      `${API_BASE_URL}${GET_USER_PERMISSIONS}?OrgId=${userDataSession.OrgId}&RoleId=${userDataSession.RoleId}&ModuleId=0`
    )
      .then((response) => {
        // setUserPermissions(response.data.ResultData);
        sessionStorage.setItem(
          "UserPermissions",
          JSON.stringify(response.data.ResultData)
        );
        // console.log(response.data.ResultData, 'user permissonsss data....');
      })
      .catch((error) => {
        console.error("Error fetching user permissions:", error);
      });
  };

  useEffect(() => {
    if (userDataSession && userDataSession.OrgId) {
      Axios.get(
        `${API_BASE_URL}${GET_DDL}?&LoggedInUser=${userDataSession.UserId}&OrgId=${userDataSession.OrgId}`
      )
        .then((response) => {
          if (response.data) {
            const allData = response.data.ResultData;

            const ddlNames = [
              "Supplier",
              "CATEGORY",
              "Subcategories",
              "Products",
              "variantypes",
              "TAX",
              "Stores",
              "BRAND",
              "Roles",
              "Staff",
              "Customers",
              "UNITS",
              "Cities",
            ];

            ddlNames.forEach((name) => {
              const filteredData = allData.filter(
                (item) => item.DDLName === name
              );
              sessionStorage.setItem(
                `filteredDDLData_${name}`,
                JSON.stringify(filteredData)
              );
            });

            console.log("Filtered data saved successfully");
          } else {
            console.error("Error fetching data:", response.data);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    }
  }, [userDataSession]);

  //   useEffect(() => {
  //   if (userDataSession && userDataSession.OrgId) {
  //     Axios.get(
  //       `${API_BASE_URL}Admin/getOrgSettings?OrgId=${userDataSession.OrgId}`
  //     )
  //       .then((response) => {
  //         if (response.data) {
  //           sessionStorage.setItem(
  //             "OrgSettings",
  //             JSON.stringify(response?.data?.ResultData?.[0])
  //           );
  //           console.log("Org settings saved successfully");
  //         } else {
  //           console.error("Error fetching org settings:", response.data);
  //         }
  //       })
  //       .catch((error) => {
  //         console.error("Error fetching org settings:", error);
  //       });
  //   }
  // }, [userDataSession]);
  
  const supplierData = JSON.parse(
    sessionStorage.getItem("filteredDDLData_Supplier")
  );
  const categoryData = JSON.parse(
    sessionStorage.getItem("filteredDDLData_CATEGORY")
  );
  const subcategoryData = JSON.parse(
    sessionStorage.getItem("filteredDDLData_Subcategories")
  );
  const productData = JSON.parse(
    sessionStorage.getItem("filteredDDLData_Products")
  );
  const variantypesData = JSON.parse(
    sessionStorage.getItem("filteredDDLData_variantypes")
  );
  const taxData = JSON.parse(sessionStorage.getItem("filteredDDLData_TAX"));
  const storesData = JSON.parse(
    sessionStorage.getItem("filteredDDLData_Stores")
  );
  const brandsData = JSON.parse(
    sessionStorage.getItem("filteredDDLData_BRAND")
  );
  const rolesData = JSON.parse(sessionStorage.getItem("filteredDDLData_Roles"));
  const staffData = JSON.parse(sessionStorage.getItem("filteredDDLData_Staff"));
  const customerData = JSON.parse(
    sessionStorage.getItem("filteredDDLData_Customer")
  );
  const unitsData = JSON.parse(sessionStorage.getItem("filteredDDLData_UNITS"));
  const citiesData = JSON.parse(
    sessionStorage.getItem("filteredDDLData_Cities")
  );

  useEffect(() => {
    console.log(supplierData);
    console.log(categoryData);
    console.log(subcategoryData);
    console.log(variantypesData);
    console.log(taxData);
    console.log(productData);
    console.log(brandsData);
    console.log(rolesData);
    console.log(staffData);
    console.log(storesData);
    console.log(customerData);
    console.log(unitsData);
    console.log(citiesData);
  }, []);

  const showViewIndentModal = (dataObj) => {
    setViewIndentObj(dataObj);
  };

  const showViewPRModal = (dataObj) => {
    setViewPRObj(dataObj);
  };

  const showViewSupplierModal = (dataObj) => {
    setViewSupplierObj(dataObj);
  };

  const showViewInvoiceModal = (dataObj) => {
    setViewInvoiceObj(dataObj);
  };

  useEffect(() => {
    if (userDataSession && userDataSession.OrgId && selectedStoreId) {
      console.log("Fetching data for storeId:", selectedStoreId);

      const fetchDropdownsData = (table_api) => {
        Axios.get(table_api)
          .then((response) => {
            setDashboardTablesData(response.data);
            console.log(
              "Fetched dashboard tables data:",
              selectedStoreId,
              response.data
            );
          })
          .catch((error) => {
            console.error("Error fetching dashboard tables data:", error);
          });

        Axios.get(
          `${API_BASE_URL}${GET_DASHBOARD_COUNT}?OrgId=${userDataSession.OrgId}&StoreId=${selectedStoreId}&UserId=${userDataSession.UserId}`
        )
          .then((response) => {
            setDashboardCountsData(response.data.ResultData);
            console.log(
              "Fetched dashboard counts data:",
              response.data.ResultData
            );
          })
          .catch((error) => {
            console.error("Error fetching dashboard counts data:", error);
          });
      };

      if (selectedStoreId == 0) {
        const table_api = `${API_BASE_URL}${GET_DASHBOARD_TABLES_DATA}?OrgId=${userDataSession.OrgId}&StoreId=${selectedStoreId}&UserId=${userDataSession.UserId}`;
        console.log(table_api, "Fetching data for all stores");
        fetchDropdownsData(table_api);
      } else {
        const table_api = `${API_BASE_URL}${GET_DASHBOARD_TABLES_DATA}?OrgId=${userDataSession.OrgId}&StoreId=${selectedStoreId}&UserId=${userDataSession.UserId}`;
        console.log(table_api, "Fetching data for specific store");
        fetchDropdownsData(table_api);
      }
    } else {
      console.log("Skipping fetch: OrgId or selectedStoreId not set");
    }
  }, [selectedStoreId]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const fetchLateIndents = () => {
    if (userDataSession && userDataSession?.OrgId && userDataSession?.UserId) {
      setLateIndentReqsLoading(true);
      Axios.get(`${API_BASE_URL}${GET_LATE_INDENT_REQ}?OrgId=${userDataSession.OrgId}&UserId=${userDataSession.UserId}`)
        .then((response) => {
          console.log(response.data, 'late indent reqs list');
          if (response.data.Status) {
            setLateIndentReqsLoading(false);
            setLateIndentReqs(response.data.ResultData);
          } else {
            setLateIndentReqsLoading(false);
            console.error("Error fetching data:", response.data.Message);
          }
        })
        .catch((error) => {
          setLateIndentReqsLoading(false);
          console.error("Error fetching data:", error);
        });
    }
  };

  useEffect(() => {
    fetchLateIndents();
  }, [userDataSession]);

  useEffect(() => {
    setUpdatedRequests(lateIndentReqs);
  }, [lateIndentReqs]);

  const formatDateForInput = (dateString) => {
    if (!dateString) {
      console.warn('Invalid date string:', dateString);
      return '';
    }

    const date = new Date(dateString);

    if (isNaN(date.getTime())) {
      console.warn('Invalid date value:', dateString);
      return '';
    }

    const formattedDate = date.toISOString().slice(0, 16);
    return formattedDate;
  };

  const handleUpdateRequest = (id, orgId, updatedData) => {
    const requestBody = {
      Id: id,
      OrgId: orgId,
      FromDate: updatedData.FromDate,
      ToDate: updatedData.ToDate,
      Status: updatedData.Status,
      UpdatedBy: 3,
    };
    console.log(requestBody, 'data sending to api for late indent ipdate');

    Axios
      .post(`${API_BASE_URL}${UPDATE_LATE_INDENT_REQ}`, requestBody)
      .then((response) => {
        fetchLateIndents();
        console.log('Response:', response.data);
      })
      .catch((error) => {
        console.error('Error updating request:', error);
      });
  };

  const handleAccept = (item) => {
    const updatedData = {
      FromDate: item.FromDate,
      ToDate: item.ToDate,
      Status: 2,
    };
    handleUpdateRequest(item.Id, item.OrgId, updatedData);
  };

  const handleReject = (item) => {
    const updatedData = {
      FromDate: item.FromDate,
      ToDate: item.ToDate,
      Status: 3,
    };
    handleUpdateRequest(item.Id, item.OrgId, updatedData);
  };

  // const handleDateChange = (index, field, value) => {
  //   const newRequests = [...updatedRequests];
  
  //   const date = new Date(value);
  
  //   if (!isNaN(date.getTime())) {
  //     const adjustedDate = new Date(date.getTime() + date.getTimezoneOffset());
  
  //     newRequests[index][field] = adjustedDate.toISOString();
  //     setUpdatedRequests(newRequests);
  //   } else {
  //     console.warn('Invalid date selected:', value);
  //   }
  // };

  const handleDateChange = (index, field, value) => {
    const newRequests = [...updatedRequests];
  
    const date = new Date(value);
  
    if (!isNaN(date.getTime())) {
      // Correctly adjust for timezone offset in milliseconds
      const adjustedDate = new Date(date.getTime() - (date.getTimezoneOffset() * 60000));
  
      // Save the full ISO string to preserve the correct date and time in UTC format
      newRequests[index][field] = adjustedDate.toISOString();
      setUpdatedRequests(newRequests);
    } else {
      console.warn('Invalid date selected:', value);
    }
  };
  
  

  const statusOrder = {
    1: "Request",
    2: "Approved",
    3: "Rejected",
    4: "Closed",
  };

  
  const statusClassNames = {
    1: "badge bg-outline-warning",
    2: "badge bg-outline-success",
    3: "badge bg-outline-danger",
    4: "badge bg-outline-secondary",
  };

  // console.log(dashboardTablesData)


  return (
    <>{loading&&<SpinLoader/>}
      <div className="page-wrapper">
        <div className="content">
          <div className="welcome d-lg-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center welcome-text">
              <h3 className="d-flex align-items-center">
                <ImageWithBasePath src="assets/img/icons/hi.svg" alt="img" />
                &nbsp;Hi {userDataSession.Name},
              </h3>
              &nbsp;
              <h6>here&apos;s what&apos;s happening with your store today.</h6>
            </div>
            <div className={`d-flex align-items-center ${[1, 2, 4].includes(userDataSession.RoleId) ? "d-block" : "d-none"}`}>
                <button
                  className="btn btn-primary"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasRightLateIndentReqApprove"
                  aria-controls="offcanvasRightLateIndentReqApprove"
                >
                  Approval Late Indents
                </button>
              </div>
          </div>
          <div className="row sales-cards justify-content-evenly">
            <div className="col-xl-2 col-sm-6 col-12">
              <Link to="/store-list">
                <div className="card color-info bg-primary mb-4">
                  <img src={NoOfStores} alt="img" style={{ width: "2.7rem" }} />
                  <h4 className="text-white">
                    {" "}
                    <CountUp
                      end={
                        dashboardCountsData &&
                        dashboardCountsData?.[0]?.TotalStores
                          ? dashboardCountsData[0].TotalStores
                          : 0
                      }
                      duration={4}
                    >
                      +
                    </CountUp>
                  </h4>
                  <p>No of Stores</p>
                </div>
              </Link>
            </div>
            <div className="col-xl-2 col-sm-6 col-12">
              <Link to="/purchase-list">
                <div className="card color-info bg-success mb-4">
                  <img src={Purchase} alt="img" style={{ width: "2.7rem" }} />
                  <h4 className="text-white">
                    ₹
                    <CountUp
                      end={
                        dashboardTablesData && dashboardTablesData.TotalPurchase
                          ? dashboardTablesData.TotalPurchase[0].TotalPurchase
                          : 0
                      }
                      duration={4}
                    >
                      +
                    </CountUp>
                  </h4>
                  <p>Total Purchase</p>
                </div>
              </Link>
            </div>
            <div className="col-xl-2 col-sm-6 col-12">
              <div className="card color-info bg-secondary mb-4">
                <img
                  src={StockValue}
                  style={{ width: "2.7rem" }}
                  alt="supplier svg"
                />
                <h4 className="text-white">
                  
                  <CountUp
                    end={
                      dashboardTablesData && dashboardTablesData.TotalStock
                        ? dashboardTablesData.TotalStock[0].TotalStock / 1000000
                        : 0
                    }
                    duration={4}
                  >
                    +
                  </CountUp>{" "}
                  M
                </h4>
                <p>Total Stock Value</p>
              </div>
            </div>
            <div className="col-xl-2 col-sm-6 col-12">
              <Link to="/suppliers">
                <div className="card color-info bg-info mb-4">
                  <img
                    src={Supplier}
                    style={{ width: "2.7rem" }}
                    alt="supplier svg"
                  />
                  <h4 className="text-white">
                    {" "}
                    <CountUp
                      end={
                        dashboardCountsData &&
                        dashboardCountsData?.[0]?.TotalSuppliers
                          ? dashboardCountsData[0].TotalSuppliers
                          : 0
                      }
                      duration={4}
                    >
                      +
                    </CountUp>
                  </h4>
                  <p>Total Supplier</p>
                </div>
              </Link>
            </div>
            <div className="col-xl-2 col-sm-6 col-12">
              <div className="card color-info bg-dark mb-4">
                <img
                  src={PendingTransfer}
                  style={{ width: "2.7rem" }}
                  alt="supplier svg"
                />
                <h4 className="text-white">
                  {" "}
                  ₹
                  <CountUp
                    end={
                      dashboardCountsData &&
                      dashboardCountsData?.[0]?.PendingStockTransfers
                        ? dashboardCountsData[0].PendingStockTransfers
                        : 0
                    }
                    duration={4}
                  >
                    +
                  </CountUp>
                </h4>
                <p>Pending Transfers </p>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12 col-md-12 col-xl-4 d-flex">
              <div className="card flex-fill default-cover w-100 mb-4">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <h4 className="card-title m3 text-info">
                    <i className="fa-solid fa-cubes me-2"></i>
                    Most Ordered Products
                  </h4>
                  <Link
                    to="/purchase-list"
                  >
                    <div className="arrow-ribbone-right bg-teal fw-bold shadow">
                      {dashboardTablesData?.mostOrderedProducts?.[0]?.TotalProductCount ?? 0}
                    </div>
                  </Link>
                </div>
                <div className="card-body">
                  <div className="table-responsive">
                    <table className="table table-borderless best-seller">
                      <tbody>
                        {dashboardTablesData &&
                          dashboardTablesData.mostOrderedProducts &&
                          dashboardTablesData.mostOrderedProducts.map(
                            (item, index) => (
                              <tr key={index}>
                                <td>
                                  <div className="product-info">
                                    <div className="info">
                                      <Link
                                        to="/product-list"
                                        className="text-primary fw-bold"
                                      >
                                        {item.ProductName}
                                      </Link>
                                    </div>
                                  </div>
                                </td>
                                <td>
                                  <p className="head-text">
                                    {item.CategoryName}
                                  </p>
                                </td>
                                <td>
                                  <p className="head-text">
                                    Orders: {item.ProductCount}
                                  </p>
                                </td>
                              </tr>
                            )
                          )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-sm-12 col-md-12 col-xl-4 d-flex">
              <div className="card flex-fill default-cover w-100 mb-4">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <h4 className="card-title mb-0 text-info">
                    <i className="fa-regular fa-paste me-2"></i>
                    Recent Stock Request
                  </h4>
                  <Link
                    to="/purchase-requests"
                  >
                    <div className="arrow-ribbone-right bg-teal fw-bold shadow"> {dashboardTablesData?.recentStockRequests?.[0]?.TotalPurchaseRequestCount ?? 0}</div>
                  </Link>
                </div>
                <div className="card-body">
                  <div className="table-responsive">
                    <table className="table table-borderless best-seller">
                      <tbody>
                        {dashboardTablesData &&
                          dashboardTablesData.recentStockRequests &&
                          dashboardTablesData.recentStockRequests.map(
                            (item, index) => (
                              <tr key={index}>
                                <td>
                                  <div className="product-info">
                                    <div className="info">
                                      <span
                                        className="fw-bold text-primary"
                                        data-bs-toggle="offcanvas"
                                        data-bs-target="#offcanvasRightPRView"
                                        aria-controls="offcanvasRightPRView"
                                        onClick={() => showViewPRModal(item)}
                                        style={{ cursor: 'pointer' }}
                                      >
                                        PR-{item.AutoGenTransactionNo}
                                      </span>
                                      <p
                                        className={`fw-semibold ${
                                          item.Status === "PENDING"
                                            ? "text-warning"
                                            : item.Status === "COMPLETED"
                                            ? "text-success"
                                            : item.Status === "DRAFT"
                                            ? "text-info"
                                            : item.Status === "REJECTED"
                                            ? "text-danger"
                                            : ""
                                        }`}
                                      >
                                        {item.Status === "DRAFT"
                                          ? "Draft"
                                          : item.Status === "PENDING"
                                          ? "PENDING"
                                          : item.Status === "COMPLETED"
                                          ? "Completed"
                                          : item.Status === "REJECTED"
                                          ? "Rejected"
                                          : ""}
                                      </p>
                                    </div>
                                  </div>
                                </td>
                                <td>
                                  {item.StoreName}
                                  <p className="head-text">
                                    {formatDate(item.RequestDate)}
                                  </p>
                                </td>
                                <td>
                                  Items
                                  <p className="head-text text-info">
                                    {item.TransactionDetailCount}
                                  </p>
                                </td>
                              </tr>
                            )
                          )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-sm-12 col-md-12 col-xl-4 d-flex">
              <div className="card flex-fill default-cover w-100 mb-4">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <h4 className="card-title mb-0 text-info">
                    <i className="fa-regular fa-hourglass-half me-2"></i>
                    Pending Indents
                  </h4>
                  <Link
                    to="/indent-list"
                  >
                    <div className="arrow-ribbone-right bg-teal fw-bold shadow"> {dashboardTablesData?.pendingIndents?.[0]?.TotalCount ?? 0}</div>
                  </Link>
                </div>
                <div className="card-body">
                  <div className="table-responsive">
                    <table className="table table-borderless best-seller">
                      <tbody>
                        {dashboardTablesData &&
                          dashboardTablesData.pendingIndents &&
                          dashboardTablesData.pendingIndents.map(
                            (item, index) => (
                              <tr key={index}>
                                <td>
                                  <div className="product-info">
                                    <div className="info">
                                      <p 
                                        className="dull-text text-primary fw-bold"
                                        data-bs-toggle="offcanvas"
                                        data-bs-target="#offcanvasRightIndView"
                                        aria-controls="offcanvasRightIndView"
                                        onClick={() => showViewIndentModal(item)}
                                        style={{ cursor: 'pointer' }}
                                      >
                                        {item.IndentNo}
                                      </p>
                                    </div>
                                  </div>
                                </td>
                                <td>
                                  <p className="head-text">{item.StoreName}</p>
                                </td>
                                <td>{formatDate(item.IndentDt)}</td>
                              </tr>
                            )
                          )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-sm-12 col-md-12 col-xl-4 d-flex">
              <div className="card flex-fill default-cover w-100 mb-4">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <h4 className="card-title mb-0 text-info">
                    <i className="fa-solid fa-truck me-2"></i>
                    Top POs from Suppliers
                  </h4>
                  <Link
                    to="/purchase-list"
                  >
                    <div className="arrow-ribbone-right bg-teal fw-bold shadow"> {dashboardTablesData?.TopPOsFromSuppliers?.[0]?.TotalOrderCount ?? 0}</div>
                  </Link>
                </div>
                <div className="card-body">
                  <div className="table-responsive">
                    <table className="table table-borderless best-seller">
                      <tbody>
                        {dashboardTablesData &&
                          dashboardTablesData.TopPOsFromSuppliers &&
                          dashboardTablesData.TopPOsFromSuppliers.map(
                            (item, index) => (
                              <tr key={index}>
                                <td>
                                  <div className="product-info">
                                    <div className="info">
                                      <Link 
                                        className="text-primary fw-semibold"
                                        // data-bs-toggle="offcanvas"
                                        // data-bs-target="#offcanvasRightPOView"
                                        // aria-controls="offcanvasRightPOView"
                                        // onClick={() => showViewPOModal(item)}
                                        // style={{ cursor: 'pointer' }}
                                      >
                                        {item.SupplierName}
                                      </Link>
                                    </div>
                                  </div>
                                </td>
                                <td>
                                  <p className="head-text">{item.City}</p>
                                </td>
                                <td>
                                  <p className="head-text">
                                    Orders:{" "}
                                    <span className="text-success fw-bold">
                                      {item.Orders}
                                    </span>
                                  </p>
                                </td>
                              </tr>
                            )
                          )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-sm-12 col-md-12 col-xl-4 d-flex">
              <div className="card flex-fill default-cover w-100 mb-4">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <h4 className="card-title mb-0 text-info">
                    <i className="fa-solid fa-users me-2"></i>
                    Recent Suppliers
                  </h4>
                  <Link
                    to="/suppliers"
                  >
                    <div className="arrow-ribbone-right bg-teal fw-bold shadow">{dashboardTablesData?.RecentSuppliers?.[0]?.TotalSupplierCount ?? 0}</div>
                  </Link>
                </div>
                <div className="card-body">
                  <div className="table-responsive">
                    <table className="table table-borderless best-seller">
                      <tbody>
                        {dashboardTablesData &&
                          dashboardTablesData.RecentSuppliers &&
                          dashboardTablesData.RecentSuppliers.map(
                            (item, index) => (
                              <tr key={index}>
                                <td>
                                  <div className="product-info">
                                    <div className="info">
                                      <Link
                                        to="#"
                                        className="text-info fw-bold"
                                        data-bs-toggle="modal"
                                        data-bs-target="#view-supplier"
                                        onClick={() => showViewSupplierModal(item)}
                                      >
                                        {item.SupplierName}
                                      </Link>
                                    </div>
                                  </div>
                                </td>
                                <td>
                                  <p className="head-text">{item.City}</p>
                                </td>
                                <td>
                                  <p className="head-text">{item.PhoneNo}</p>
                                </td>
                              </tr>
                            )
                          )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-sm-12 col-md-12 col-xl-4 d-flex">
              <div className="card flex-fill default-cover w-100 mb-4">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <h4 className="card-title mb-0 text-info">
                    <i className="fa-solid fa-calendar-xmark me-2"></i>
                    Pending Invoices
                  </h4>
                  <Link
                    to="/invoices"
                  >
                    <div className="arrow-ribbone-right bg-teal fw-bold shadow">{dashboardTablesData?.PendingInvoice?.[0]?.TotalPendingCount ?? 0}</div>
                  </Link>
                </div>
                <div className="card-body">
                  <div className="table-responsive">
                    <table className="table table-borderless best-seller">
                      <tbody>
                        {dashboardTablesData &&
                          dashboardTablesData.PendingInvoice &&
                          dashboardTablesData.PendingInvoice.map(
                            (item, index) => (
                              <tr key={index}>
                                <td>
                                  <div className="product-info">
                                    <div className="info">
                                      <Link
                                        className="fw-bold text-primary"
                                        data-bs-toggle="offcanvas"
                                        data-bs-target="#offcanvasRightInvView"
                                        aria-controls="offcanvasRightInvView"
                                        onClick={() => showViewInvoiceModal(item)}
                                        style={{ cursor: 'pointer' }}
                                      >
                                        INV-{item.AutoGenTransactionNo}
                                      </Link>
                                    </div>
                                  </div>
                                </td>
                                <td>
                                  <p className="head-text">
                                    RS.{item.InvoiceAmount}/-
                                  </p>
                                </td>
                                <td>
                                  <p className="head-text">
                                    {formatDate(item.InvoiceDate)}
                                  </p>
                                </td>
                              </tr>
                            )
                          )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

          {/* Late indents  */}
          <div
            className="offcanvas offcanvas-end"
            tabIndex={-1}
            id="offcanvasRightLateIndentReqApprove"
            aria-labelledby="offcanvasRightLabel"
            style={{ minWidth: '68%', maxWidth: '68%' }}
          >
            <div className="offcanvas-header">
              <h4 id="offcanvasRightLabel">Requests of Late Indents</h4>
              <div className="d-flex ms-auto align-items-center">
                <button
                  type="button"
                  className="btn-close text-reset ms-2"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                />
              </div>
            </div>
            <hr />
            <div className="offcanvas-body">
              <div className="table-responsive" style={{ maxHeight: '30rem', overflowY:' auto' }}>
                <table className="table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Store</th>
                      <th>Start Date</th>
                      <th>End Date</th>
                      <th>Status</th>
                      <th>Reason</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {lateIndentReqsLoading ? (
                      <tr>
                        <td colSpan={12} className="text-center">
                          <div className="loader m-auto d-flex"></div>
                        </td>
                      </tr>
                    ) : (
                      updatedRequests?.map((item, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{item.StoreName}</td>
                          <td>
                            <input
                              type="datetime-local"
                              className="form-control"
                              value={formatDateForInput(item.FromDate)}
                              onChange={(e) => handleDateChange(index, 'FromDate', e.target.value)}
                            />
                          </td>
                          <td>
                            <input
                              type="datetime-local"
                              className="form-control"
                              value={formatDateForInput(item.ToDate)}
                              onChange={(e) => handleDateChange(index, 'ToDate', e.target.value)}
                            />
                          </td>
                          <td>
                            <span  className={statusClassNames[item.Status]}>{statusOrder[item.Status]}</span>
                          </td>
                          <td>
                            <Popover
                              placement="bottom"
                              title="Reason"
                              content={
                                <div style={{ width: '400px', maxHeight: '150px', overflowY: 'auto' }}>
                                  <p>{item.Reason}</p>
                                </div>
                              }
                              getPopupContainer={(trigger) => trigger.parentNode}
                              zIndex={1050}
                            >
                              <i
                                className="fa-regular fa-comment fs-4 text-info"
                                style={{ cursor: 'pointer' }}
                              ></i>
                            </Popover>
                          </td>
                          <td>
                            <div className="edit-delete-action">
                              <Link
                                to="#"
                                className="dropdown-oggle nav-link select-store"
                                data-bs-toggle="dropdown"
                              >
                                <i className="fa-solid fa-ellipsis-vertical btn border"></i>
                              </Link>
                              <div className="dropdown-menu dropdown-menu-right">
                                <Link
                                  to="#"
                                  className={`dropdown-item ms-3 mb-3 mt-2 ${item.Status === 1 || item.Status === 3 ? '' : 'disabled'}`}
                                  onClick={() => handleAccept(item)}
                                >
                                  <i className="fa-solid fa-check me-2 text-success"></i>
                                  Accept
                                </Link>
                                <Link
                                  to="#"
                                  className={`dropdown-item ms-3 mb-3 mt-3  ${item.Status === 1 || item.Status === 2 ? '' : 'disabled'}`}
                                  onClick={() => handleReject(item)}
                                >
                                  <i className="fa-solid fa-xmark me-2 text-danger"></i>
                                  Reject
                                </Link>
                              </div>
                            </div>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>


        <ViewIndent IndentObj={viewIndentObj} />
        <ViewPurchaseRequest tranViewObj={viewPRObj} />
        <SupplierModal supplierObj={viewSupplierObj} />
        <ViewInvocie INVObj={viewInvoiceObj} />
        {/* <ViewPurchase POObj={viewPOObj} /> */}
      </div>
    </>
  );
};

export default InventoryDashboard;
